"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeleteTodoResponse = exports.UpdateTodoResponse = exports.CreateTodoResponse = exports.GetTodoResponse = exports.ListTodoAssigneesResponse = exports.ListTodosResponse = exports.ListTodosQuery = exports.TodoDetailsParams = exports.CompleteTodoRequest = exports.UpdateTodoRequest = exports.CreateTodoRequest = exports.TodoItemSchema = exports.TodoSubtaskSchema = exports.TodoAssigneeOptionSchema = exports.TODO_PRIORITY_DEFAULT = exports.TODO_PRIORITY_MAX = exports.TODO_PRIORITY_MIN = exports.TODO_TITLE_MAX_LENGTH = exports.TodoSort = void 0;
const zod_1 = require("zod");
var TodoSort;
(function (TodoSort) {
    TodoSort["PRIORITY"] = "priority";
    TodoSort["DUE_DATE"] = "dueDate";
})(TodoSort || (exports.TodoSort = TodoSort = {}));
exports.TODO_TITLE_MAX_LENGTH = 120;
exports.TODO_PRIORITY_MIN = 0;
exports.TODO_PRIORITY_MAX = 4;
exports.TODO_PRIORITY_DEFAULT = 0;
const TodoPrioritySchema = zod_1.z.number().int().min(exports.TODO_PRIORITY_MIN).max(exports.TODO_PRIORITY_MAX);
const TodoAssigneeSchema = zod_1.z.object({
    id: zod_1.z.string(),
    firstName: zod_1.z.string(),
    lastName: zod_1.z.string(),
});
exports.TodoAssigneeOptionSchema = TodoAssigneeSchema.extend({
    userPermissionName: zod_1.z.string().nullable(),
});
const TodoJobSummarySchema = zod_1.z.object({
    id: zod_1.z.string(),
    quoteId: zod_1.z.string(),
});
exports.TodoSubtaskSchema = zod_1.z.object({
    id: zod_1.z.string(),
    parentId: zod_1.z.string(),
    title: zod_1.z.string(),
    priority: TodoPrioritySchema,
    dueDate: zod_1.z.string().date().nullable(),
    completedAt: zod_1.z.string().nullable(),
    assignedUser: TodoAssigneeSchema,
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.TodoItemSchema = zod_1.z.object({
    id: zod_1.z.string(),
    parentId: zod_1.z.string().nullable(),
    title: zod_1.z.string(),
    priority: TodoPrioritySchema,
    dueDate: zod_1.z.string().date().nullable(),
    completedAt: zod_1.z.string().nullable(),
    assignedUser: TodoAssigneeSchema,
    createdBy: TodoAssigneeSchema,
    job: TodoJobSummarySchema.nullable(),
    subtasks: zod_1.z.array(exports.TodoSubtaskSchema),
    createdAt: zod_1.z.string(),
    updatedAt: zod_1.z.string(),
});
exports.CreateTodoRequest = zod_1.z.object({
    title: zod_1.z.string().min(1).max(exports.TODO_TITLE_MAX_LENGTH),
    priority: TodoPrioritySchema.default(exports.TODO_PRIORITY_DEFAULT),
    assignedUserId: zod_1.z.string(),
    dueDate: zod_1.z.string().date().nullable().optional(),
    jobId: zod_1.z.string().nullable().optional(),
    parentId: zod_1.z.string().nullable().optional(),
});
exports.UpdateTodoRequest = zod_1.z.object({
    title: zod_1.z.string().min(1).max(exports.TODO_TITLE_MAX_LENGTH).optional(),
    priority: TodoPrioritySchema.optional(),
    assignedUserId: zod_1.z.string().optional(),
    dueDate: zod_1.z.string().date().nullable().optional(),
    jobId: zod_1.z.string().nullable().optional(),
});
exports.CompleteTodoRequest = zod_1.z.object({
    completed: zod_1.z.boolean(),
});
exports.TodoDetailsParams = zod_1.z.object({
    id: zod_1.z.string(),
});
exports.ListTodosQuery = zod_1.z.object({
    sort: zod_1.z.nativeEnum(TodoSort).optional(),
    jobId: zod_1.z.string().optional(),
    includeCompleted: zod_1.z.coerce.boolean().optional(),
});
exports.ListTodosResponse = zod_1.z.object({
    data: zod_1.z.array(exports.TodoItemSchema),
});
exports.ListTodoAssigneesResponse = zod_1.z.object({
    data: zod_1.z.array(exports.TodoAssigneeOptionSchema),
});
exports.GetTodoResponse = zod_1.z.object({
    data: exports.TodoItemSchema,
});
exports.CreateTodoResponse = zod_1.z.object({
    data: exports.TodoItemSchema,
});
exports.UpdateTodoResponse = zod_1.z.object({
    data: exports.TodoItemSchema,
});
exports.DeleteTodoResponse = zod_1.z.object({
    data: zod_1.z.object({
        id: zod_1.z.string(),
    }),
});
